module.exports = __webpack_public_path__ + "img/left_arrow.3775272.svg";